import { FC } from 'react';

import { NbPageHeader } from '@/components/Neobrut';

export const TyC: FC = () => {
  return (
    <div className="mx-auto w-full max-w-2xl lg:max-w-3xl pb-10">
      <NbPageHeader
        slug="/ términos y condiciones"
        title={<>Términos y<br />condiciones.</>}
        tone="plain"
      />
      <ol className="flex list-decimal flex-col gap-4 px-8 pt-4 text-justify text-[14px] leading-relaxed">
        <li>
          <div>
            <div className="font-bold">Descripción del Servicio</div>
            <p>
              RescatApp es una plataforma digital sin fines de lucro que permite a los usuarios
              publicar y consultar información sobre animales perdidos y encontrados en Rosario. El
              propósito de la plataforma es facilitar la conexión entre personas para ayudar a
              recuperar animales perdidos.
            </p>
          </div>
        </li>

        <li>
          <div>
            <div className="font-bold">Registro y Responsabilidad del Usuario</div>
            <p>
              Para utilizar RescatApp, el usuario debe registrarse proporcionando datos verídicos y
              completos. Usted es responsable de mantener la confidencialidad de su cuenta y
              contraseña, así como de todas las actividades que se realicen bajo su cuenta. Los
              usuarios se comprometen a usar la plataforma de manera legal y ética.
            </p>
          </div>
        </li>

        <li>
          <div>
            <div className="font-bold">Publicación de Anuncios</div>
            <p>
              Los usuarios pueden publicar anuncios relacionados con animales perdidos o
              encontrados. Al hacerlo, el usuario acepta los siguientes términos:
            </p>
            <ul className="list-inside list-disc pt-2">
              <li>
                Los anuncios deben ser precisos y no violar ninguna ley local ni los derechos de
                propiedad intelectual de terceros.
              </li>
              <li>
                NO se permite la publicación de anuncios relacionados con la venta o adopción de
                animales. RescatApp es una plataforma exclusivamente para animales perdidos y
                encontrados.
              </li>
              <li>
                No se pueden publicar anuncios que incluyan contenido ofensivo, difamatorio, ilegal
                o que infrinja los derechos de otras personas.
              </li>
              <li>
                RescatApp se reserva el derecho de eliminar cualquier anuncio que infrinja estos
                términos sin previo aviso.
              </li>
            </ul>
          </div>
        </li>

        <li>
          <div>
            <div className="font-bold">Protección de Datos Personales</div>
            <p>
              RescatApp recopila y procesa datos personales de acuerdo con nuestra Política de
              Privacidad. Al utilizar nuestros servicios, usted consiente el uso de sus datos
              personales de acuerdo con esta política.
            </p>
          </div>
        </li>

        <li>
          <div>
            <div className="font-bold">Limitación de Responsabilidad</div>
            <p>
              RescatApp no se hace responsable por la exactitud de la información publicada en los
              anuncios ni por la resolución de los casos de animales perdidos o encontrados. No
              garantizamos el éxito en la recuperación de los animales ni nos hacemos responsables
              de las interacciones entre los usuarios.
            </p>
          </div>
        </li>

        <li>
          <div>
            <div className="font-bold">Propiedad Intelectual</div>
            <p>
              Todos los derechos de propiedad intelectual relacionados con RescatApp, incluyendo,
              pero no limitándose a, nombres, logotipos, gráficos, diseño y software, son propiedad
              de RescatApp o de sus creadores, Andrés y Victoria. La aplicación y su identidad
              visual fueron desarrolladas íntegramente por los responsables del proyecto. Algunas
              imágenes utilizadas en la plataforma provienen de bancos de imágenes de uso gratuito y
              se emplean conforme a sus respectivas licencias. No se concede ninguna licencia ni
              derecho sobre estos materiales sin el permiso expreso de RescatApp.
            </p>
          </div>
        </li>

        <li>
          <div>
            <div className="font-bold">Modificaciones</div>
            <p>
              RescatApp se reserva el derecho de modificar estos Términos y Condiciones en cualquier
              momento. Cualquier cambio será publicado en esta página y, al continuar usando la
              plataforma, usted acepta las modificaciones.
            </p>
          </div>
        </li>

        <li>
          <div>
            <div className="font-bold">Terminación del Servicio</div>
            <p>
              RescatApp puede suspender o cancelar el acceso a la aplicación en cualquier momento si
              se considera que el usuario ha violado estos Términos y Condiciones. En caso de
              terminación, se eliminará el acceso a la cuenta y a los anuncios.
            </p>
          </div>
        </li>

        <li>
          <div>
            <div className="font-bold">Ley Aplicable y Jurisdicción</div>
            <p>
              RescatApp es un proyecto sin fines de lucro creado en Argentina. En caso de surgir
              algún inconveniente relacionado con el uso de la aplicación, se aplicarán las leyes de
              la República Argentina, y cualquier eventualidad será resuelta en los tribunales
              ordinarios de la ciudad de Rosario, Santa Fe.
            </p>
          </div>
        </li>

        <li>
          <div>
            <div className="font-bold">Acerca de la propiedad de RescatApp</div>
            <p>
              RescatApp fue creada y es gestionada por Andrés y Victoria. Correo electrónico de
              contacto: contacto@rescatapp.com.ar
            </p>
          </div>
        </li>
      </ol>
    </div>
  );
};
